var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#96bf72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.85,58.3h-30.15c-.28,0-.53-.15-.66-.4-.13-.25-.11-.54.04-.77l11.39-16.64c.14-.2.37-.33.62-.33h30.15c.28,0,.53.15.66.4.13.25.11.54-.04.77l-11.39,16.64c-.14.2-.37.33-.62.33Zm-28.73-1.5h28.33l10.36-15.14h-28.33l-10.36,15.14Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.08,58.3c-.15,0-.29-.04-.42-.13-.34-.23-.43-.7-.2-1.04l11.39-16.64c.23-.34.7-.43,1.04-.19.34.23.43.7.2,1.04l-11.39,16.64c-.15.21-.38.33-.62.33Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.46,58.3c-.15,0-.29-.04-.42-.13-.34-.23-.43-.7-.2-1.04l11.39-16.64c.23-.34.7-.43,1.04-.19.34.23.43.7.2,1.04l-11.39,16.64c-.15.21-.38.33-.62.33Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.85,73.49h-41.85c-.41,0-.75-.34-.75-.75v-15.19c0-.41.34-.75.75-.75s.75.34.75.75v14.44h40.35v-13.49c0-.41.34-.75.75-.75h2.9l-8.17-16.51c-.18-.37-.03-.82.34-1,.37-.19.82-.03,1,.34l8.71,17.59c.12.23.1.51-.03.73-.14.22-.38.35-.64.35h-3.35v13.49c0,.41-.34.75-.75.75Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.85,73.49c-.41,0-.75-.34-.75-.75v-15.19c0-.41.34-.75.75-.75s.75.34.75.75v15.19c0,.41-.34.75-.75.75Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.85,59.25c-.28,0-.54-.15-.67-.41l-7.03-14.04c-.19-.37-.04-.82.33-1.01.37-.19.82-.04,1.01.33l7.03,14.04c.19.37.04.82-.33,1.01-.11.05-.22.08-.33.08Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.31,47.4h-30.15c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h30.15c.41,0,.75.34.75.75s-.34.75-.75.75Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.78,52.56h-30.15c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h30.15c.41,0,.75.34.75.75s-.34.75-.75.75Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.5e9f47dbfd5bc819a1c7a6a23a2ce8a1.svg";
export { ForwardRef as ReactComponent };